module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Products")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.product.name))])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', [_c('router-link', {
    staticClass: "button is-info",
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id) + "/fw_updates/create")
    }
  }, [_vm._v("Upload new firmware")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('p', [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.fwUpdatesTotal)))]), _vm._v(" firmware updates")])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal
    },
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("Deleting firmware update")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('span', {
    staticClass: "icon is-large has-text-danger"
  }, [_c('i', {
    staticClass: "fa fa-3x fa-exclamation-triangle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', [_vm._v("Are you sure you want to "), _c('strong', [_vm._v("delete")]), _vm._v(" this firwmare update?")]), _vm._v(" "), _c('p', [_vm._v("This action cannot be undone.")])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger",
    on: {
      "click": function($event) {
        _vm.deleteItem(_vm.fwUpdateId)
      }
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("Cancel")])])])]), _vm._v(" "), _c('pagination', {
    staticClass: "is-small",
    attrs: {
      "urlBuilder": _vm.buildPaginatorUrls,
      "currentPage": _vm.currentPage,
      "lastPage": _vm.lastPage,
      "displayPage": 5
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(!this.$store.state.fwUpdates.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No firmware updates found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.fwUpdates), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": (_vm.apiUrl + "/fw_updates/" + (item.filename))
      }
    }, [_vm._v(_vm._s(item.filename))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.version))]), _vm._v(" "), _c('td', {
      staticClass: "text-column"
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updated_at))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "title": "Delete firmware file"
      },
      on: {
        "click": function($event) {
          _vm.showModal = true;
          _vm.fwUpdateId = item.id
        }
      }
    }, [_vm._m(2, true)])])])
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Firmware updates")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Filename")]), _vm._v(" "), _c('th', [_vm._v("Version")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Updated at")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon has-text-danger"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-trash"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e989d2f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FwUpdates/FwUpdateList.vue
// module id = 224
// module chunks = 1